import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Shell } from "./components/Shell";
import { SoundProvider, useGlobalSound } from "./hooks/SoundContext";
import { HomePage } from "./pages/HomePage";
import { RoomPage } from "./pages/RoomPage";
import { UiPreviewPage } from "./pages/UiPreviewPage";
import { VisualEffectsProvider } from "./hooks/VisualEffectsContext";

function AppContent() {
  const sound = useGlobalSound();

  return (
    <Shell soundEnabled={sound.enabled} onToggleSound={() => void sound.toggle()}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/room/:roomCode" element={<RoomPage />} />
        {import.meta.env.DEV && <Route path="/__ui-preview" element={<UiPreviewPage />} />}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Shell>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <VisualEffectsProvider>
        <SoundProvider>
          <AppContent />
        </SoundProvider>
      </VisualEffectsProvider>
    </BrowserRouter>
  );
}
